import { useMutationApi, useQueryApi } from 'utils/api'

import type { IContentCollectionData } from 'types/self-improvement'

const BASE_PATH = '/guru/content-platform/v1alpha1/self-improvement'

export type TAssessmentTypes = 'RPD'
export type TContentTypes = 'INDICATOR'

interface ResponseBodyContentCollection {
  data: IContentCollectionData[]
}

interface IIndicatorRequest {
  key: string
  reason: string
  needs: string
}

type TStatePlan = 'DRAFTED' | 'ON_CONFRIMATION'

export interface RequestBodyPlan {
  state: TStatePlan
  indicators: IIndicatorRequest[]
}

interface ResponseBodyPlan {
  data: {
    id: string
    userId: string
    state: TStatePlan
    feedback: string
    indicators: IIndicatorRequest[]
  }
}

export function useAPISelfImprovementContentCollection(
  assessmentType: TAssessmentTypes,
  contentTypes: TContentTypes
) {
  return useQueryApi<ResponseBodyContentCollection>(
    `${BASE_PATH}/content-collection`,
    {
      axiosConfig: {
        params: {
          assessmentType,
          contentTypes,
        },
      },
    }
  )
}

export function useAPISelfImprovementPlan() {
  return useQueryApi<ResponseBodyPlan>(`${BASE_PATH}/plan`, {
    queryConfig: {
      useErrorBoundary: false,
    },
  })
}

export function useMutateAPISelfImprovementPlan() {
  return useMutationApi<any, Error, RequestBodyPlan>(`${BASE_PATH}/plan`, {
    axiosConfig: { method: 'PATCH' },
  })
}
